<template>
  <div class="duallo-loader-wrapper">
    <div v-if="loading" class="loader-content">
      <v-progress-circular indeterminate color="#66c7b4" size="32" />
      <div v-if="message" class="loading-text">{{ message }}</div>
    </div>

    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DualloLoaderWrapper',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.duallo-loader-wrapper {
  width: 100%;
  height: 100%;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #b0bec5;
  min-height: 150px; /* Adjust depending on context */
}

.loading-text {
  margin-top: 12px;
  font-size: 1rem;
}
</style>
